import useTranslator from "../../../../hooks/useTranslator";
import lockIcon from "../../../../assets/img/lockIcon.svg";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import { FiCamera, FiClock, FiUserCheck } from "react-icons/fi";
import styles from "../authenticateYourId.module.css";

const VerificationStartScreen = ({
  onStart,
  isLoading = false,
}: {
  onStart: () => void;
  isLoading?: boolean;
}) => {
  const { _t } = useTranslator();

  const expectations = [
    {
      icon: <FiCamera aria-hidden="true" />,
      text: _t("takeAPhotoOfYourDocumentOrUploadItFromYourDevice"),
    },
    {
      icon: <FiUserCheck aria-hidden="true" />,
      text: _t("theDocumentMustIncludeYourPhotoANieWithoutAPhotoIsNotValid"),
    },
    {
      icon: <FiClock aria-hidden="true" />,
      text: _t("theResultIsUsuallyReadyInLessThanAMinute"),
    },
  ];

  return (
    <div className={styles.kycVerificationStart}>
      <div className={styles.kycVerificationStartIcon} aria-hidden="true">
        <BadgeOutlinedIcon />
      </div>

      <div className={styles.kycVerificationStartCopy}>
        <h3>{_t("verifyYourIdentity")}</h3>
        <p>{_t("haveYourDniPassportOrResidenceCardReady")}</p>
      </div>

      <div className={styles.kycVerificationExpectations}>
        {expectations.map(({ icon, text }) => (
          <div className={styles.kycVerificationExpectation} key={text}>
            <span className={styles.kycVerificationExpectationIcon}>
              {icon}
            </span>
            <strong>{text}</strong>
          </div>
        ))}
      </div>

      <div className={styles.kycVerificationStartActions}>
        <div className={styles.kycVerificationStartButtonPanel}>
          <button
            type="button"
            className={`btnNext ${styles.kycVerificationStartButton}`}
            onClick={onStart}
            disabled={isLoading}
            aria-busy={isLoading}
          >
            {isLoading && (
              <span
                className={styles.kycVerificationStartButtonSpinner}
                aria-hidden="true"
              />
            )}
            {isLoading ? _t("startingVerification") : _t("startVerification")}
          </button>
        </div>

        <p className={styles.kycVerificationLegal}>
          {_t("identityVerificationAmlLegalCopy")}{" "}
          <a
            href="https://skortorent.com/legal-notice.html"
            target="_blank"
            rel="noreferrer"
          >
            {_t("moreInformation")}
          </a>
        </p>

        <div className={styles.kycVerificationEncryptedNote}>
          <img src={lockIcon} alt="" />
          <span>{_t("yourDataIsEncrypted")}</span>
        </div>
      </div>
    </div>
  );
};

export default VerificationStartScreen;
